import styled from '@emotion/styled'

import TemplateHeader from '@/components/templates/TemplateHeader'
import TemplateHero from '@/components/templates/TemplateHero'
import { TemplateButton } from '@/components/templates/TemplateButton'
import TemplateNavigation from '../../../components/templates/TemplateNavigation'

const Layout = styled.section``

Layout.Header = styled(TemplateHeader)`
  display: flex;
  height: 70px;
`

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;
`

Layout.Navigation = styled(TemplateNavigation)`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 3em;
`

Layout.Link = styled.span`
  margin-left: 10px;
  font-weight: 700;
  font-size: 16px;
`

Layout.SubHeader = styled.div`
  display: flex;
  background: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme }) => theme.palette.text.primary};
  height: 60px;
  position: relative;
  z-index: 1;
`

Layout.SubHeaderTitle = styled.span`
  margin: auto;
`

Layout.Hero = styled(TemplateHero)``

Layout.HeroContainer = styled.div`
  display: flex;
  min-height: calc(var(--preview-height) - 130px);
  max-height: calc(var(--preview-height) - 130px);
  width: 100%;
  flex-wrap: wrap;
  z-index: 1;
  position: relative;
`

Layout.TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  max-width: 994px;
`

Layout.Title = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  align-self: center;
  z-index: 5;
  margin-bottom: 14px;
`

Layout.Subtitle = styled.p`
  font-size: 22px;
`
Layout.CTA = styled(TemplateButton)`
  line-height: 2.2;
  min-width: 152px;
  max-width: 256px;
  padding: 5px 30px;
  margin-top: 14px;
  border-width: 2px;
  border-radius: 0;
`

Layout.Button = styled(TemplateButton)`
  border-radius: 0;
  padding: 3px 30px;
  margin: 20px 0;
  line-height: 2.2;
  svg {
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }
`
export default Layout
